import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { BehaviorSubject, Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { SpecUsbIconComponent } from '../../../shared/components/icons/generated/spec-usb/spec-usb.component';
import { SpecOxidationIconComponent } from '../../../shared/components/icons/generated/spec-oxidation/spec-oxidation.component';
import { SpecMicrophoneIconComponent } from '../../../shared/components/icons/generated/spec-microphone/spec-microphone.component';
import { SpecSoundIconComponent } from '../../../shared/components/icons/generated/spec-sound/spec-sound.component';
import { SpecBluetoothIconComponent } from '../../../shared/components/icons/generated/spec-bluetooth/spec-bluetooth.component';
import { SpecWifiIconComponent } from '../../../shared/components/icons/generated/spec-wifi/spec-wifi.component';
import { SpecCameraIconComponent } from '../../../shared/components/icons/generated/spec-camera/spec-camera.component';
import { SpecBatteryIconComponent } from '../../../shared/components/icons/generated/spec-battery/spec-battery.component';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'app-featured-verified-specs-card',
  templateUrl: './featured-verified-specs-card.template.html',
  styleUrls: ['./featured-verified-specs-card.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,
    SpecBatteryIconComponent,
    SpecCameraIconComponent,
    SpecWifiIconComponent,
    SpecBluetoothIconComponent,
    SpecSoundIconComponent,
    SpecMicrophoneIconComponent,
    SpecOxidationIconComponent,
    SpecUsbIconComponent,
    AsyncPipe,
  ],
})
export class FeaturedVerifiedSpecsCardComponent {
  public readonly lessThan$: Observable<ScreenSizeInfoState>;
  public readonly biggerThan$: Observable<ScreenSizeInfoState>;

  public readonly contentExpanded$: Observable<boolean>;
  private readonly contentSubject: BehaviorSubject<boolean>;

  constructor(private readonly akitaScreenQuery: AkitaScreenQuery) {
    this.contentSubject = new BehaviorSubject('' as any);
    this.contentExpanded$ = this.contentSubject.asObservable();

    this.lessThan$ = this.akitaScreenQuery.selectLessThan();
    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();

    if (this.akitaScreenQuery.lessThan.sm) {
      this.contentSubject.next(false);
    } else {
      this.contentSubject.next(true);
    }
  }

  public switchExpanded(): void {
    if (this.contentSubject.value) {
      this.contentSubject.next(false);
    } else {
      this.contentSubject.next(true);
    }
  }
}
